import React from "react";
import { FiSearch } from "react-icons/fi";

/**
 * Compact filter bar: search + optional status/date presets + optional date picker.
 */
export default function ListFiltersBar({
  searchValue,
  onSearchChange,
  searchPlaceholder = "Kërko…",
  statusTabs,
  activeStatusTab,
  onStatusTabChange,
  datePresets,
  activeDatePreset,
  onDatePresetChange,
  customDate = "",
  onCustomDateChange,
  resultCount,
  resultLabel = "rezultat",
  selectValue = "",
  selectOptions,
  onSelectChange,
  selectAriaLabel = "Filtro",
  selectPlaceholder = "Të gjithë",
}) {
  const hasStatus = Array.isArray(statusTabs) && statusTabs.length > 0;
  const hasDate = Array.isArray(datePresets) && datePresets.length > 0;
  const hasSelect = Array.isArray(selectOptions) && selectOptions.length > 0 && onSelectChange;

  return (
    <div className="p-3 border-b border-slate-200 space-y-2 bg-slate-50">
      <div className="input-icon-wrap">
        <FiSearch className="input-icon" size={17} aria-hidden />
        <input
          type="search"
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={searchPlaceholder}
          className="input-with-icon bg-white"
        />
      </div>

      {(hasStatus || hasDate || hasSelect) && (
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:flex-wrap">
          {hasStatus && (
            <div className="flex flex-wrap gap-1.5">
              {statusTabs.map((tab) => (
                <button
                  key={tab.value}
                  type="button"
                  onClick={() => onStatusTabChange(tab.value)}
                  className={activeStatusTab === tab.value ? "tab-active" : "tab-inactive"}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          )}

          {hasSelect && (
            <select
              value={selectValue}
              onChange={(e) => onSelectChange(e.target.value)}
              className="input py-1.5 w-auto min-w-[12rem] max-w-full"
              aria-label={selectAriaLabel}
            >
              <option value="">{selectPlaceholder}</option>
              {selectOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          )}

          {hasDate && (
            <div className="flex flex-wrap items-center gap-1.5 sm:ml-auto">
              {datePresets.map((opt) => (
                <button
                  key={opt.value}
                  type="button"
                  onClick={() => onDatePresetChange(opt.value)}
                  className={
                    !customDate && activeDatePreset === opt.value ? "tab-active" : "tab-inactive"
                  }
                >
                  {opt.label}
                </button>
              ))}
              {onCustomDateChange && (
                <input
                  type="date"
                  value={customDate}
                  onChange={(e) => onCustomDateChange(e.target.value)}
                  className="input py-1.5 px-2.5 w-auto text-sm min-w-0"
                  aria-label="Zgjidh datë"
                />
              )}
            </div>
          )}

          {typeof resultCount === "number" && (
            <span className="text-xs text-slate-500 sm:w-full lg:w-auto lg:ml-0">
              {resultCount} {resultLabel}
              {resultCount !== 1 ? "e" : ""}
            </span>
          )}
        </div>
      )}

      {!hasStatus && !hasDate && !hasSelect && typeof resultCount === "number" && (
        <p className="text-xs text-slate-500">
          {resultCount} {resultLabel}
          {resultCount !== 1 ? "e" : ""}
        </p>
      )}
    </div>
  );
}
